<template>
  <div>
    <div class="container bg-white m-auto py-4 px-8 max-w-screen-sm" v-if="!loading" :class="{companion: isCompanion}">
      <div v-if="isCompanion" class="image-container max-w-screen-sm">
        <img class="m-auto mb-8 w-64" alt='Companion App' src='../../assets/images/companion-logo.png'>
        <img v-if="this.profile.Image_URL" class="object-contain max-h-16 mb-8 ml-8 w-64" alt='Branding Image' :src="this.profile.Image_URL">
      </div>
      <div v-else>
        <div v-if="language_id === 1" class="image-container max-w-screen-sm">
          <img class="m-auto mb-8 w-64" alt='Connections App' src='../../assets/images/logo.png'>
          <img v-if="this.profile.Image_URL" class="object-contain max-h-16 mb-8 ml-8 w-64" alt='Branding Image' :src="this.profile.Image_URL">
        </div>
        <div v-else class="image-container max-w-screen-sm">
          <img class="m-auto mb-8 w-64" alt='Conexiones App' src='../../assets/images/conexiones.png'>
          <img v-if="this.profile.Image_URL" class="object-contain max-h-16 mb-8 ml-8 w-64" alt='Branding Image' :src="this.profile.Image_URL">
        </div>
      </div>
      <div v-if="hasToken && (loadingFields || this.profile.Enabled)">
        <div class="header" v-if="!loadingFields">
          <!-- if patient form -->
          <div v-if="this.profile.Patient_Setup">
            <p class="my-4 font-bold text-base" v-html="detectLinks(profile.Customer_Name)"></p>
            <!-- explainer video -->
            <div v-if="showVideo" class="video-container">
              <video
                controls
                playsinline
                width="65%"
                autoplay
                muted
              >
                <source :src="videoUrl" type="video/mp4" />
                Connections Explainer video.
              </video>
            </div>
            <p class="my-4">{{ isCompanion ? language.companion_description[language_id] : language.description[language_id] }}</p>
            <p class="my-4">{{ language.anonymity[language_id] }}</p>
          </div>
          <!-- if staff form -->
          <div v-else>
            <!-- selected staff is Untrained -->
            <div v-if="this.profile.StaffArray.length > 0 && this.getStaffEnrollerStatus(true)">
              <p class="my-4 font-bold text-base">{{ displayName() }}, {{ language.welcome_to_enrollment_form[language_id] }} {{ isCompanion ? 'Companion' : 'Connections'}} App</p>
              <p class="my-4" v-html="detectLinks(profile.Customer_Name)"></p>
            </div>
            <!-- selected staff is not Untrained -->
            <div v-else-if="this.profile.StaffArray.length > 0 && this.getStaffEnrollerStatus()">
              <p class=" my-4 font-bold text-base">{{ language.welcome_back[language_id] }} {{ displayName() }}</p>
              <p class="my-4" v-html="detectLinks(profile.Customer_Name)"></p>
            </div>
            <!-- if there are no QEL staff or staff selected is not listed or staff selected is null -->
            <div v-else>
              <p class="my-4 font-bold text-base" v-html="detectLinks(profile.Customer_Name)"></p>
            </div>
          </div>
          <div v-if="this.profile.Patient_Setup">
            <p class="mt-4">{{ language.fill_form[language_id] }}</p>
          </div>
          <div v-else>
            <p class="mt-4">{{ language.staff_enroll_form[language_id] }}</p>
          </div>
        </div>
        <div class="form flex flex-wrap text-left max-w-screen-sm m-auto py-4" v-if="!loadingFields">
          <FormField v-for="field in fields" :key="field" :field="patientData[field].key"
            :label="patientData[field].label" :type="patientData[field].type" :value="patientData[field].value"
            :required="patientData[field].required" :requiredMessage="patientData[field].requiredMessage"
            :disabled="patientData[field].disabled" :fieldClass="patientData[field].class" :maxlength="patientData[field].maxlength || ''"
            :enable="patientData[field].enable" :language_id="language_id" :hidden="patientData[field].hidden"
            :entityOptions="entityList" @update="updateField(field, $event)" @blur="checkDOB(field, $event)" />
          <button v-if="this.patientData.email.hidden" class="underline-button" @click="showEmailField">{{ this.language.show_email[this.language_id] }}</button>
          <div class="w-full text-center mb-4">
            <p class="my-4" v-if="isCompanion">Clicking Submit will generate a SMS text message to the individual with an invitation to use the Companion App in the form of a download link and temporary password. By agreeing to receive the invitation, the individual permits CHESS Health to use text messages or phone calls to offer technical and login assistance.</p>
            <p class="my-4" v-if="!isCompanion">{{ this.language.submit_message[this.language_id] }}</p>
            <button id="submit" class="w-24" @click="submitForm">{{ this.language.submit[this.language_id] }}</button>
          </div>
        </div>
        <LoadingUI class="mb-4" msg="Loading..." v-if="loadingFields" />
        <div class="footer pb-4">
          <p class="mb-2" v-if="isCompanion">{{ language.questions[language_id] }} <a
              href="mailto:support@companion.health">support@companion.health</a></p>
          <p class="mb-2" v-else-if="this.profile.Patient_Setup">{{ language.questions[language_id] }} <a
              href="mailto:support@connectionsapp.com">support@connectionsapp.com</a></p>
          <p class="mb-2" v-else>{{ language.questions[language_id] }} <a
              href="mailto:support@connectionsapp.com">support@connectionsapp.com</a></p>
          <p v-if="language_id == 1"><a href="https://www.chess.health/privacy-policy/"
              target="_blank">{{ language.privacy_policy[1] }}</a></p>
          <p v-else><a href="https://www.chess.health/privacy-policy-for-the-conexiones-app/"
                target="_blank">{{ language.privacy_policy[2] }}</a></p>
        </div>
      </div>
      <div v-if="hasToken && !this.profile.Enabled && !loadingFields">
        <p class="my-4 font-bold text-base">{{ language.link_no_valid[language_id] }}</p>
        <p class="my-4" v-if="isCompanion">{{ language.questions[language_id] }} <a
            href="mailto:support@connectionsapp.com">support@companion.health</a></p>
        <p class="my-4" v-else-if="this.profile.Patient_Setup">{{ language.questions[language_id] }} <a
              href="mailto:support@connectionsapp.com">support@connectionsapp.com</a></p>
        <p class="my-4" v-else>{{ language.questions[language_id] }} <a
              href="mailto:support@connectionsapp.com">support@connectionsapp.com</a></p>
      </div>
      <div v-if="!hasToken">
        <p class="my-4 font-bold text-base">Something went wrong.</p>
        <p class="my-4" v-if="isCompanion">{{ language.questions[language_id] }} <a
            href="mailto:support@companion.health">support@companion.health</a></p>
        <p class="my-4" v-else-if="this.profile.Patient_Setup">{{ language.questions[language_id] }} <a
              href="mailto:support@connectionsapp.com">support@connectionsapp.com</a></p>
        <p class="my-4" v-else>{{ language.questions[language_id] }} <a
              href="mailto:support@connectionsapp.com">support@connectionsapp.com</a></p>
      </div>
    </div>
    <div ref="modalContainer"></div>
    <LoadingUI msg="Setting up account..." :overlay="true" v-if="loading && language_id == 1" />
    <LoadingUI msg="Creación de la cuenta" :overlay="true" v-if="loading && language_id == 2" />
  </div>
</template>

<script>
import Vue from 'vue'
import SuccessModal from '../Integration-Profile/SuccessModal.vue'
import PEXCardModal from '../Integration-Profile/PEXCardModal.vue'
import FormField from '../Integration-Profile/FormField.vue'
import LoadingUI from '../LoadingUI.vue'
import BirthValidationModal from '../Integration-Profile/BirthValidationModal.vue'
import StaffSelectionModal from '../Integration-Profile/StaffSelectionModal.vue'
import { createPatient, getIntegrationProfile } from '../../services/integration-profile-service'
import { translations } from '../../translations'
import { getEntityPrograms } from '../../services/contingency-management-service'
import { incrementQEL } from '../../services/integration-profile-service'
import EnrollementStatusModal from '../Integration-Profile/EnrollementStatusModal.vue'
import DuplicateWarningModal from './DuplicateWarningModal.vue'

export default {
  name: 'Home',
  components: { // imported components
    LoadingUI,
    FormField,
  },
  props: { // props passed into component
    fullToken: {
      type: String,
      required: true,
    },
    isCompanion: Boolean ?? false
  },
  data() { // component props
    return {
      hasToken: false,
      loading: false,
      loadingFields: false,
      language_id: 1,
      language: translations(),
      modalOpen: false,
      patientData: {},
      profile: {},
      fields: [],
      markAsReadOnly: false,
      cmPrograms: [],
      entityPrograms: [],
      selectedStaff: null,
      entityList: [],
      showVideo: false,
      videoUrl: ""
    }
  },
  created() { /* Called synchronously after the instance is created */

    if (this.fullToken != "") {
      this.hasToken = true;
    }

    if (this.hasToken) {
      this.loadingFields = true;
      this.loading = true;
      // get integration profile based on token
      getIntegrationProfile(this.fullToken).then(res => {
        if (res.success && res.data) {

          this.profile = res.data.integration_profile;

          if (this.profile?.Name?.toLowerCase().includes('video')) {
            this.showVideo = true;
          }

          if (res.data.entity_list) {
            this.entityList = res.data.entity_list.map(e => ({ id: e.Entity_ID, name: e.Name }));
          }
          let community = this.profile.Communities;
          this.cmPrograms = this.profile.CM_EntityProgram?.split(',') || [];
          // get the full reward program records to determine if we need to show PEX Card modal at the end
          if (this.cmPrograms.length) {
            this.getEntityPrograms();
          }
          //if entity has name "training" and has communities
          //set read_only for community to true
          for (let entity of this.entityList.map(e => e.name)) {
            if (entity.includes("Training") && community != "") {
              this.markAsReadOnly = true;
            }
          }
          if (this.profile.Language_ID == 0 || (this.profile.Language_ID == undefined || this.profile.Language_ID == null)) {
            this.language_id = 1
          } else {
            this.language_id = this.profile.Language_ID
          }
          // emit language returned in integration profile back to App.vue
          this.$emit('update-language', this.language_id);
          this.videoUrl = this.language.video_url[this.language_id]
          this.resetPatientData();

          this.profile.StaffArray = this.profile.Users;

          //check if staff was selected and cached
          let staffSelectedCached = null;
          const staff = sessionStorage.getItem('staffSelectedCached');
          if (staff) {
            staffSelectedCached = JSON.parse(staff);
          }

          //check if profile is for staff and has QEL staff assigned to it
          if (!this.profile.Patient_Setup && this.profile.StaffArray.length > 0) {
            if(this.profile.StaffArray.length > 1) {
              //if more than 1 staff show staff selection modal
              if(!staffSelectedCached) {
                this.createStaffSelectionModal(this.profile, this.isCompanion);
              } else {
                this.assignStaffToProfile(staffSelectedCached);
              }
            } else {
              //if 1 staff assign that to profile automatically
              this.assignStaffToProfile(this.profile.StaffArray[0]);
            }
          }
          this.loading = false;

          this.$emit('brandingImageUrl', this.profile.Image_URL);
          this.$emit('profileID', this.profile.ID);

          this.loadingFields = false;

        } else {
          // if it gets here, profile is disabled
          this.profile.Enabled = false;
          this.loadingFields = false;
          this.loading = false;

        }
      }, err => {
        console.log(err);
        this.hasToken = false;
        this.loadingFields = false;
        this.loading = false;
      });
    }
  },
  mounted() { /* Called after the instance has been mounted */ },
  methods: { // component functions
    submitForm() {
      const today = new Date()
      const birthDate = new Date(this.patientData.dob.value)
      let age = today.getFullYear() - birthDate.getFullYear();
      const month_diff = today.getMonth() - birthDate.getMonth();
      const day_diff = today.getDate() - birthDate.getDate();
      if (month_diff < 0 || (month_diff === 0 && day_diff < 0)) {
        age--;
      }
      if (age < 13) {
        this.$toastr.Add({
          title: "Age Error",
          msg: "Patient under 13 years old cannot be created.",
          type: "error",
          position: "toast-bottom-right",
          style: { "width": "auto", "min-width": "300px" }
        });
        return; 
      }

      // bind field values to model first to make sure values are populated
      this.bindFields();
      let invalid = this.invalidFields();
      if (invalid.length) {
        // build error message
        let message = '';
        invalid.forEach(field => {
          message += `- ${this.patientData[field].label} is invalid<br>`;
        });
        this.$toastr.Add({
          title: "Invalid Fields",
          msg: message,
          type: "error",
          position: "toast-bottom-right",
          style: { "width": "auto", "min-width": "300px" }
        });
      } else {
        const toastOptions = {
          title: "Error",
          msg: this.language.problem[this.language_id],
          type: "error",
          position: "toast-bottom-right",
          style: { "width": "430px" }
        };
        this.loading = true;
        // create patient record
        let data = this.requestData();
        data.entities = this.addDefaultEntities()
        data.Read_Only_Option = this.markAsReadOnly;
        data.enrolled_by_id = this.selectedStaff?.User_ID ?? null;
        createPatient(data).then(res => {
          if (res.success) {
            this.loading = false;
            // assign patient data returned
            data['sso_id'] = res.data.SSO_ID;
            data['user_id'] = res.data.User_ID;
            data['user_guid'] = res.data.patient_guid;
            data['temp_pass'] = res.data.temp_pass;
            data['no_connections_app'] = res.data.no_connections_app;
            data['enrollment_ids'] = res.data.enrollment_ids || [];
            // create new instance of the modal and show
            //if intergation profile is for staff
            if (!this.profile.Patient_Setup && this.selectedStaff) {
              // if they were enrolled in an eligible reward program, show the card modal
              if (this.cmPrograms.length && data.enrollment_ids.length) {
                this.createPEXCardModal(data, true, this.isCompanion);
                //if staff enrollment form and patient was already enrolled but not onboarded
              } else if (res.data.Message == "Text and email sent. Same birthdate and phone number") {
                this.createSuccessModal(data, this.isCompanion, false, true);
              } else {
                this.createEnrollmentStatusModal(data, this.selectedStaff, this.isCompanion);
              }
            } else {
              this.createSuccessModal(data, this.isCompanion);
            }
            const toastTracking = {
              title: "Error",
              msg: 'Could not track QEL completion.',
              type: "error",
              position: "toast-bottom-right",
              style: { "width": "430px" }
            };
            // Increment QEL Completed Count
            incrementQEL(this.fullToken, false, true).catch(err => {
              console.error(err);
              this.$toastr.Add(toastTracking);
            })
            // reset patient data fields
            this.resetPatientData();
          } else {
            this.resetPatientData();
            this.loading = false;
            //if patient is already enrolled and onboarded
            if(res.message == "The current patient is not new") {
              this.createSuccessModal(data, this.isCompanion, true);
            } else {
              this.createWarningModal(this.isCompanion);
              // this.$toastr.Add(toastOptions);
            }
          }
        }).catch(err => {
          this.resetPatientData();
          console.error(err);
          this.loading = false;
          this.$toastr.Add(toastOptions);
        });
      }
    },
    resetPatientData() {
      this.patientData = {
        first_name: { key: 'first_name', label: this.language.first_name[this.language_id], value: '', type: 'text', required: true, order: 1 },
        last_name: { key: 'last_name', label: this.language.last_name[this.language_id], value: '', type: 'text', required: true, order: 2 },
        dob: { key: 'dob', label: this.language.date_birth[this.language_id], value: this.isCompanion ? '1900-01-01' : '', type: 'date', required: this.isCompanion ? false : true, requiredMessage: this.isCompanion ? false : true, order: 3, hidden: this.isCompanion ? true : false },
        mobile: { key: 'mobile', label: this.language.phone[this.language_id], value: '', type: 'phone', required: true, order: 4 },
        gender_id: { key: 'gender_id', label: this.language.gender[this.language_id], value: '', type: 'select', required: true, order: 5 },
        email: { key: 'email', label: this.language.email[this.language_id], value: '', type: 'text', required: false, order: 25, hidden: true },
        language_id: { key: 'language_id', value: `${this.language_id}`, disabled: true }
      };
      // conditionally add entity dropdown
      if (this.profile.Not_Defaulted_Entities) {
        this.patientData['entity_id'] = { key: 'entity_id', label: this.language.entity[this.language_id], value: '', type: 'multiselect', required: true, order: 6 };
      }
      // handle extra fields
      this.parseExtraFields();
      // get and sort keys
      let fields = [];
      let keys = Object.keys(this.patientData);
      keys.forEach(key => {
        if (this.patientData[key].type) {
          fields.push({
            key: this.patientData[key].key,
            order: this.patientData[key].order
          });
        }
      });
      this.fields = fields.sort(function (a, b) {
        if (a.order < b.order) { return -1; }
        if (a.order > b.order) { return 1; }
        return 0;
      }).map(field => field.key);

      const toastTracking = {
        title: "Error",
        msg: 'Could not track QEL opening.',
        type: "error",
        position: "toast-bottom-right",
        style: { "width": "430px" }
      };
      // Increment QEL Opened Count
      incrementQEL(this.fullToken, true, false).catch(err => {
        console.error(err);
        this.$toastr.Add(toastTracking);
      })
    },
    requestData() {
      let obj = {};
      let keys = Object.keys(this.patientData);
      let values = Object.values(this.patientData);
      values.forEach((v, i) => {
        obj[keys[i]] = v.value;
      });
      return obj;
    },
    invalidFields() {
      let fields = [];
      let keys = Object.keys(this.patientData);
      let values = Object.values(this.patientData);
      let empty = values.map((v, i) => {
        return { value: v.value, index: i, required: v.required }
      }).filter(v => !v.value && v.required);
      if (empty.length > 0) {
        empty.forEach(e => {
          let key = keys[e.index];
          fields.push(key);
        });
      }
      keys.forEach(key => {
        // check if zip code has digits only and its 5 digits
        if (this.patientData[key].type === 'zip' && this.patientData[key].value) {
          if (!/^\d{5}$/.test(this.patientData[key].value)) {
            fields.push(key);
          }
        }
      });
      return fields;
    },
    bindFields() {
      let keys = Object.keys(this.patientData);
      keys.forEach(key => {
        let field = document.getElementsByName(key)[0];
        if (field) {
          this.patientData[key].value = field.value;
        }
      });
    },
    createSuccessModal(patient, isCompanion, onboarded = false, enrolled = false) {
      let ModalComponent = Vue.extend(SuccessModal);
      let instance = new ModalComponent({
        propsData: { patient, isCompanion, patientSetup: this.profile.Patient_Setup, language_id: this.language_id, onboarded: onboarded, enrolled: enrolled }
      });
      instance.$mount();
      instance.$on('close-modal', () => {
        // if they were enrolled in an eligible reward program, show the card modal
        if (this.cmPrograms.length && patient.enrollment_ids.length) {
          this.createPEXCardModal(patient, false, isCompanion);
        }
      });
      this.$refs.modalContainer.innerHTML = '';
      this.$refs.modalContainer.appendChild(instance.$el);
      this.$modal.show('success');
    },
    createValidationModal() {
      let ModalComponent = Vue.extend(BirthValidationModal);
      let instance = new ModalComponent({});
      instance.$mount();
      this.$refs.modalContainer.innerHTML = '';
      this.$refs.modalContainer.appendChild(instance.$el);
      this.$modal.show('validation');
    },
    createPEXCardModal(patient, showEnrollmentModal, isCompanion) {
      let ModalComponent = Vue.extend(PEXCardModal);
      let instance = new ModalComponent({
        propsData: { patient, companion: isCompanion }
      });
      instance.$mount();
      instance.$on('close-modal', () => {
        
        //show staff enrollment status modal
        if (showEnrollmentModal) {
          this.createEnrollmentStatusModal(patient, this.selectedStaff, isCompanion);
        }
      });
      this.$refs.modalContainer.innerHTML = '';
      this.$refs.modalContainer.appendChild(instance.$el);
      this.$modal.show('pex-card');
    },
    updateField(field, event) {
      // map array for multiselect
      if (this.patientData[field].type === 'multiselect') {
        this.patientData[field].value = event.map(e => e.id);
      } else {
        this.patientData[field].value = event;
      }
      if (this.patientData[field].type === 'boolean' && this.patientData[field].enable) {
        // special case for boolean fields having functionality to disable/enable fields based on true/false
        let key = this.patientData[field].enable;
        if (this.patientData[field].value == 'true') {
          this.patientData[key].disabled = false;
          this.patientData[key].required = true;
        } else {
          this.patientData[key].disabled = true;
          this.patientData[key].required = false;
        }
        this.$forceUpdate();
      }
    },
    checkDOB(field, event) {
      if(!this.isCompanion) {
        this.patientData[field].value = event;
        if (this.patientData[field].type === 'date' && field === 'dob') {
          const today = new Date()
          const birthDate = new Date(event)
          if ((today.getFullYear() - birthDate.getFullYear()) >= 100) {
            this.createValidationModal();
          }

          let age = today.getFullYear() - birthDate.getFullYear();
          const month_diff = today.getMonth() - birthDate.getMonth();
          const day_diff = today.getDate() - birthDate.getDate();

          if (month_diff < 0 || (month_diff === 0 && day_diff < 0)) {
            age--;
          }

          if (age < 13) {
            this.createValidationModal();
          }
        }
      }
    },
    parseExtraFields() {
      if (this.profile.IntegrationExtraFields) {
        this.profile.IntegrationExtraFields.forEach(field => {
          let fieldName;
          if (this.language_id == 2) {
            fieldName = field.FieldVisibility.Spanish_Name;
          } else {
            fieldName = field.FieldVisibility.Name;
          }
          switch (field.Field_ID) {
            case 10:
              this.patientData['address'] = { key: 'address', label: fieldName, value: '', type: 'text', required: true, order: 7 };
              break;
            case 27:
              this.patientData['city'] = { key: 'city', label: fieldName, value: '', type: 'text', required: true, order: 8 };
              break;
            case 11:
              this.patientData['state'] = { key: 'state', label: fieldName, value: '', type: 'text', required: true, order: 9 };
              break;
            case 12:
              this.patientData['zip_code'] = { key: 'zip_code', label: fieldName, value: '', type: 'zip', required: true, order: 10, maxlength: 5 };
              break;
            case 5:
              this.patientData['race_id'] = { key: 'race_id', label: fieldName, value: '', type: 'select', required: true, order: 11 }
              break;
            case 22:
              this.patientData['payer_type_id'] = { key: 'payer_type_id', label: fieldName, value: '', type: 'select', required: true, order: 12 };
              break;
            case 23:
              this.patientData['payer_name_id'] = { key: 'payer_name_id', label: this.language.insurance[this.language_id], value: '', type: 'select', required: true, order: 13 };
              break;
            case 26:
              this.patientData['member_id'] = { key: 'member_id', label: fieldName, value: '', type: 'text', required: true, order: 14 };
              break;
            case 16:
              this.patientData['is_mat'] = { key: 'is_mat', label: fieldName, value: '', type: 'boolean', class: 'w-1/2 pr-2', enable: 'mat', required: true, order: 15 };
              this.patientData['mat'] = { key: 'mat', label: this.language.mat[this.language_id], value: '', type: 'text', required: false, class: 'w-1/2 pl-2', disabled: true, order: 16 };
              break;
            case 37:
              this.patientData['loc'] = { key: 'loc', label: fieldName, value: '', type: 'select', class: 'w-1/2 pr-2', required: true, order: 17 };
              this.patientData['loc_date'] = { key: 'loc_date', label: this.language.loc_start[this.language_id], value: '', type: 'date', class: 'w-1/2 pl-2', required: true, order: 18 };
              break;
            case 20:
              this.patientData['pregnant'] = { key: 'pregnant', label: fieldName, value: '', type: 'boolean', required: true, order: 19 };
              break;
            case 25:
              this.patientData['primary_substance_id'] = { key: 'primary_substance_id', label: fieldName, value: '', type: 'select', required: true, order: 20 };
              break;
            case 33:
              this.patientData['nhi'] = { key: 'nhi', label: fieldName, value: '', type: 'text', required: true, order: 21 };
              break;
            case 44:
              if (this.profile.Staff_Field_Notes) {
                this.patientData['note'] = { key: 'note', label: this.profile.Notes_Field_Label || this.language.staff_name[this.language_id], value: '', type: 'text', required: true, order: 22, maxlength: 255 };
              } else {
                this.patientData['note'] = { key: 'note', label: this.profile.Notes_Field_Label || fieldName, value: '', type: 'text', required: true, order: 22, maxlength: 255 };
              }
              break;
            case 45:
              this.patientData['language_id'] = { key: 'language_id', label: fieldName, type: 'select', required: true, order: 23 }
              break;
            case 6:
              this.patientData['extra_id'] = { key: 'extra_id', label: fieldName, type: 'text', required: true, order: 24 }
              break;
            case 7:
              this.patientData['email'] = { key: 'email', label: this.language.email[this.language_id], type: 'text', required: true, order: 25 }
              break;
          }
        });
      }
    },
    addDefaultEntities() {
      const region = this.profile.Region;
      let entities = [];
      const payer_id = this.patientData['payer_name_id'];
      // check for specific entities
      if (this.profile.Not_Defaulted_Entities) {
        entities = this.patientData['entity_id'].value;
      }
      // specific for CHESS1
      switch (region) {
        case 'KE_eyZa':
          if (entities.includes(133) && payer_id === 68) {
            if (!entities.length) entities = this.profile.Entity.split(',');
            entities.push(134);
          }
          if (entities.includes(135) && payer_id === 66) {
            if (!entities.length) entities = this.profile.Entity.split(',');
            entities.push(136);
          }
          break;
        default:
          break;
      }
      return entities;
    },
    getEntityPrograms() {
      // get all entity programs associated with the integration profile
      getEntityPrograms().then(res => {
        if (res.success) {
          this.entityPrograms = res.data;
          // only get programs where Reward_ID = 1 (PEX Card)
          this.cmPrograms = this.cmPrograms.filter(id => this.entityPrograms.find(ep => ep.EntityProgram_ID == id)?.Program.Reward_ID == 1);
        }
      }).catch(err => {
        console.log(err)
      });
    },
    createEnrollmentStatusModal(patient, selectedStaff, isCompanion) {
      let ModalComponent = Vue.extend(EnrollementStatusModal);
      let instance = new ModalComponent({
        propsData: { patient, selectedStaff, language_id: this.language_id, companion: isCompanion }
      });
      instance.$mount();
      this.$refs.modalContainer.innerHTML = '';
      this.$refs.modalContainer.appendChild(instance.$el);
      this.$modal.show('enrollment-status');
    },
    createStaffSelectionModal(profile, isCompanion) {
      let ModalComponent = Vue.extend(StaffSelectionModal);
      let instance = new ModalComponent({
        propsData: { profile, companion: isCompanion }
      });
      instance.$mount();
      instance.$on('close-modal', (selectedStaff) => {
        this.selectedStaff = selectedStaff;
        this.loading = false;
      });
      this.$refs.modalContainer.innerHTML = '';
      this.$refs.modalContainer.appendChild(instance.$el);
      this.$modal.show('staffSelection');
    },
    showEmailField() {
      this.patientData['email'] = { key: 'email', label: this.language.email[this.language_id], value: '', type: 'text', required: false, order: 25, hidden: false };
    },
    detectLinks(text) {
      if (text) {
        // Replace carriage returns with <br> tags
        const textWithBreaks = text.replace(/\n/g, "<br>");
        // Find URLs and convert them into clickable links
        const urlRegex = /(?:https?:\/\/|www\.)[^\s]+/g;
        return textWithBreaks.replace(urlRegex, function (match) {
          if (match.startsWith('https://') || match.startsWith('http://')) {
            return '<a href="' + match + '" target="_blank" style="text-decoration: underline;">' + match + '</a>';
          } else {
            return '<a href="https://' + match + '" target="_blank" style="text-decoration: underline;">' + match + '</a>';
          }
        });
      }
      return text;
    },
    getStaffEnrollerStatus(isUntrained = false) {
      const name = this.selectedStaff?.ClinicianSetting?.EnrollerStatus?.Name;
      const staff = name ? name.trim().toLowerCase() : '';
      if (isUntrained) {
        return staff === 'untrained';
      } else {
        return staff !== 'untrained';
      }
    },
    displayName() {
      const staff = this.selectedStaff?.First_Name ?? '';
      return staff;
    },
    errorCallback(err) {
      this.loading = false;
      console.log(err.message);
    },
    assignStaffToProfile(staffSelectedCached) {
      //if only 1 staff auto select that staff and show form
      this.selectedStaff = staffSelectedCached;
      //cache the selected staff
      sessionStorage.setItem("staffSelectedCached", JSON.stringify(this.selectedStaff));
    },
    createWarningModal(isCompanion) {
      let ModalComponent = Vue.extend(DuplicateWarningModal);
      let instance = new ModalComponent({propsData: {language_id: this.language_id, companion: isCompanion }});
      instance.$mount();
      this.$refs.modalContainer.innerHTML = '';
      this.$refs.modalContainer.appendChild(instance.$el);
      this.$modal.show('duplicate');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  border-radius: 8px;
  margin-top: 50px;
  overflow: hidden;
  box-shadow: 1px 5px 15px #9c9c9c;
}

.image-container {
  display: inline-flex;
  justify-content: center;
  max-width: 640px;
  flex-wrap: wrap;
}

button {
  height: 40px;
  font-size: 14px;
  color: #fff;
  border: none;
  padding: 6px 12px;
  border-radius: 3px;
  background: #750097;
}

a {
  color: #750097;
}

.underline-button {
  background: none;
  border: none;
  padding: 0;
  color: #750097;
  text-decoration: underline;
  cursor: pointer;
}

.video-container {
  display: flex;
  justify-content: center;
}

.companion{
  background: #fff;
  button {
    background: #2c6759;
  }
  a {
    color:#2c6759;
  }
  .underline-button {
    background: none;
    color:#2c6759
  }
}
</style>
